<template>
  <div :class="['content-toggle', { open: contentVisible }]">
    <h4>
      <button
        :id="labelId"
        :aria-controls="contentId"
        :aria-expanded="Boolean(contentVisible).toString()"
        @click="contentVisible = !contentVisible"
      >
        <span v-text="label"></span>
        <arrow></arrow>
      </button>
    </h4>
    <div
      :id="contentId"
      :aria-labelledby="labelId"
      :hidden="!contentVisible"
      role="region"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Arrow from './icons/Arrow.vue';

export default {
  name: 'ContentToggle',
  data: () => ({
    contentVisible: true,
  }),
  computed: {
    labelId() {
      // eslint-disable-next-line no-underscore-dangle
      return this.id ? `${this.id}-label` : `${this._uid}-label`;
    },
    contentId() {
      // eslint-disable-next-line no-underscore-dangle
      return this.id ? `${this.id}-content` : `${this._uid}-content`;
    },
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    id: String,
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.contentVisible = !this.collapsed;
  },
  components: { Arrow },
};
</script>

<style scoped lang="scss">
button {
  display: flex;
  justify-content: space-between;

  svg {
    display: inline-block;
    width: rem(14px);
    height: rem(24px);
    margin-top: rem(-2px);

    .content-toggle.open & {
      transform: rotate(180deg); /* TODO: animate rotation and height */
    }
  }
}
</style>
